import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section3 .swiper", {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: '1.82%',
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '3.2258%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      }
    } 
});